<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-04 16:35:40
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimBalance\components\viewTransactions.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-23 11:19:17
-->
<template>
  <normalDialog
    :title="
      $t('label_essweb_ClaimBalance_form_dialog_viewClaimTransactionTitle')
    "
    :dialog="show"
    width="700"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_ClaimBalance_form_dialog_claimTypeLabel"
              :items="claimType"
              :readonly="!isEdited"
              item-text="claim_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="TransactionsData.claim_type_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_ClaimBalance_form_dialog_transactionTypeLabel"
              :readonly="!isEdited"
              :filled="false"
              :items="Transactiontype"
              :disabled="!TransactionsData.claim_type_uuid"
              item-text="claim_transaction_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="TransactionsData.claim_transaction_type_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              type="month"
              :readonly="!isEdited"
              :filled="false"
              :defaultTime="TransactionsData.claim_period"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t('label_essweb_ClaimBalance_form_dialog_claimPeriodLabel')
              "
              @change="(time) => (TransactionsData.claim_period = time)"
            ></DateTimePicker>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet
              class="
                white--text
                rounded-lg
                pa-3
                subtitle-1
                d-flex
                justify-space-between
              "
              color="primary"
            >
              <div class="max-width">
                {{
                  $t("label_essweb_ClaimBalance_form_dialog_totalAmountLabel")
                }}:
              </div>
              <div class="max-width text-right">
                {{ TransactionsData.currency_code }}
                {{ parseFloat(Number(TransactionsData.total_amount)) }}
              </div>
              <span></span>
            </v-sheet>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :readonly="!isEdited"
              :filled="false"
              :defaultTime="TransactionsData.effective_utc_datetime"
              :max="TransactionsData.expired_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t(
                  'label_essweb_ClaimBalance_form_dialog_effectiveStartDateLabel'
                )
              "
              @change="
                (time) => (TransactionsData.effective_utc_datetime = time)
              "
            ></DateTimePicker>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :readonly="!isEdited"
              :filled="false"
              :defaultTime="TransactionsData.expired_utc_datetime"
              :min="TransactionsData.effective_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t('label_essweb_ClaimBalance_form_dialog_expiredDateLabel')
              "
              @change="(time) => (TransactionsData.expired_utc_datetime = time)"
            ></DateTimePicker>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_ClaimBalance_form_dialog_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              dense
              append-icon=""
              single-line
              v-model="TransactionsData.expired_time_zone"
              :placeholder="
                $t('label_essweb_ClaimBalance_form_dialog_timeZoneLabel')
              "
              :readonly="!isEdited"
              :filled="false"
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_ClaimBalance_form_dialog_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="TransactionsData.remarks"
              dense
              counter="500"
              single-line
              :readonly="!isEdited"
              :filled="false"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>-->
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "viewClaimTrannsactions",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: "", type: [String, Number] },
    staff_uuid: { default: "", type: [String, Number] },
    detailUuid: { default: "", type: [String, Number] },
  },
  computed: {
    ...mapGetters(["staticZone", "defaultUTC"]),
    claimType() {
      return this.$getSelectTrans(this.claimTypeData, "claim_type_name");
    },
    Transactiontype() {
      return this.$getSelectTrans(
        this.TransactiontypeData,
        "claim_transaction_type_name"
      );
    },
  },
  data() {
    return {
      claimTypeData: [],
      isEdited: false,
      claimPeriod: [],
      TransactiontypeData: [],
      TransactionsData: {
        claim_type_uuid: "",
        claim_transaction_type_uuid: "",
        currency_uuid: "",
        claim_period: "",
        total_amount: 0,
        time_zone: "480",
        effective_utc_datetime: "",
        expired_utc_datetime: "",
        expired_time_zone: "",
        remarks: "",
      },
    };
  },
  watch: {
    show(val) {
      if (!val) if (this.$refs["form"]) this.$refs["form"].reset();
    },
    detailUuid(val) {
      if (val) this.getDetail(val);
    },
    "TransactionsData.claim_type_uuid": function (val) {
      if (val) {
        this.getTransactionType(val);
      }
    },
    // "TransactionsData.claim_transaction_type_uuid": function (val) {
    //   let obj = this.TransactiontypeData.find((ele) => ele.uuid === val);
    // },
  },
  mounted() {
    this.TransactionsData.time_zone = this.defaultUTC;
    this.TransactionsData.expired_time_zone = this.defaultUTC;
    this.getClaimType();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },

    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_record",
        url: "/claim-transaction-record/get-details/",
        data: { uuid: uuid },
      }).then((res) => {
        res.data["claim_period"] =
          res.data["claim_period"].toString().substring(0, 4) +
          "/" +
          res.data["claim_period"].toString().substring(4, 6);
        // res.data["start_utc_datetime"] = this.$getDateTime(
        //   res.data["start_utc_datetime"],
        //   "YYYY-MM-DD HH:mm"
        // );
        // res.data["end_utc_datetime"] = this.$getDateTime(
        //   res.data["end_utc_datetime"],
        //   "YYYY-MM-DD HH:mm"
        // );
        res.data["effective_utc_datetime"] = this.$getDateTime(
          res.data["effective_utc_datetime"],
          "YYYY-MM-DD"
        );
        res.data["expired_utc_datetime"] = this.$getDateTime(
          res.data["expired_utc_datetime"],
          "YYYY-MM-DD"
        );
        that.TransactionsData = res.data;
      });
    },
    getClaimType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_claim_type",
        url: "/claim-type/get-claim-type-list/",
      }).then((res) => {
        that.claimTypeData = res.data;
      });
    },
    getTransactionType: function (val) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type",
        url: "/claim-transaction-type/get-list/",
        data: {
          claim_type_uuid: val,
          //  add_support_type_filter: 1 //查看不传
        },
      }).then((res) => {
        that.TransactiontypeData = res.data;
      });
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let data = {
        staff_uuid: this.curUuid,
        claim_type_uuid: this.TransactionsData.claim_type_uuid,
        claim_transaction_type_uuid:
          this.TransactionsData.claim_transaction_type_uuid,
        claim_period: dayjs(this.TransactionsData.claim_period).format(
          "YYYYMM"
        ),
        total_minutes: this.totalMinute,
        effective_utc_datetime: this.$getTimeValue(
          this.TransactionsData.effective_utc_datetime
        ),
        effective_time_zone: this.TransactionsData.time_zone,
        expired_utc_datetime: this.$getTimeValue(
          this.TransactionsData.expired_utc_datetime
        ),
        expired_time_zone: this.TransactionsData.time_zone,
        remarks: this.TransactionsData.remarks,
      };

      this.$emit("onNew", data);
    },
  },
};
</script>
